var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFocusArrow = function SvgFocusArrow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 51,
    viewBox: "0 0 38 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76829 41.2681C1.76829 42.2453 1.04567 47.1028 1.04567 48.0801C1.04567 48.3303 0.869921 48.8975 1.20795 49.0618C1.88899 49.3926 3.09301 49.5659 3.92612 49.5659C4.54438 49.5659 8.08076 49.7484 8.68293 49.8047",
    stroke: "#F6BF56",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85547 48.0976C9.85744 44.29 20.1123 39.6361 22.8989 30.6552C24.4215 25.7484 24.3504 18.2115 20.8303 14.1127C19.6746 12.7671 15.8666 9.33724 11.4947 11.2226C7.12287 13.1079 13.5266 24.1507 14.8521 25.882C19.8638 32.4283 28.299 32.2088 33.2423 24.5643C36.2625 19.8937 36.2035 13.5699 35.8104 8.2294C35.7026 6.76579 35.2904 3.48702 33.9557 2",
    stroke: "#F6BF56",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFocusArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/focus-arrow.0b14c723.svg";
export { ForwardRef as ReactComponent };